/**
 * For Google Tag Manager
 */
'use strict';

var root = typeof window === 'undefined' ? global : window;
root.dataLayer = root.dataLayer || [];
module.exports = root.dataLayer;



//////////////////
// WEBPACK FOOTER
// ./~/dibs-tracking/gtmDataLayer.js
// module id = 2082
// module chunks = 63